import Festival from "../components/events/AcappellaFest";

export default function EventPage3 () {

    return (
        <>
        <Festival/>
        </>
    )
}